export default __webpack_public_path__ + "static/media/INC Straight.7d62014a.mp3";